<template>
    <div class="call-popup-container">
        <div class="call-popup">
            <div
                class="close-btn-container d-flex align-items-center justify-content-center"
                @click="closeNotificationPopup"
            >
                <img src="../../../../assets/images/Notification/call-noti-close-icon.svg" class="close-icon" />
            </div>
            <div class="call-popup-content d-flex align-items-center justify-content-center flex-column">
                <span class="caller-name">{{ callSignalRNotification.callerName }}</span>
                <p class="call-subtitlte">
                    <span v-if="callSignalRNotification.isGroupNotification">started the meeting</span>
                    <span v-else>calling...</span>
                </p>
                <div class="d-flex justify-content-center align-items-center call-pad">
                    <img src="../../../../assets/images/Notification/call-noti-callpad.svg" class="callpad-icon" />
                </div>
            </div>
            <div class="call-popup-footer">
                <div
                    class="call-btn-wrapper call-btn d-flex align-items-center justify-content-center"
                    @click="handleCallDecline"
                >
                    <div
                        class="call-icon-container call-icon-container--decline d-flex justify-content-center align-items-center me-2"
                    >
                        <img src="../../../../assets/images/Notification/call-decline-icon.svg" class="call-btn-icon" />
                    </div>
                    <span class="call-message">Decline</span>
                </div>
                <div class="divider"></div>
                <div
                    class="call-btn-wrapper call-btn d-flex align-items-center justify-content-center"
                    @click="handleCallAccept"
                >
                    <div
                        class="call-icon-container call-icon-container--accept d-flex justify-content-center align-items-center me-2"
                    >
                        <img
                            src="../../../../assets/images/Notification/call-accepted-icon.svg"
                            class="call-btn-icon"
                        />
                    </div>
                    <span class="call-message">Join</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
    callSignalRNotification: {
        type: Object,
        required: true
    }
});

const emits = defineEmits(["close-notification", "decline-call", "accept-call"]);

let disableBtns = false;

const closeNotificationPopup = () => {
    emits("close-notification");
};

const handleCallDecline = () => {
    if (!disableBtns) {
        emits("decline-call");
    }
    disableBtns = true;
};

const handleCallAccept = () => {
    if (!disableBtns) {
        emits("accept-call", props.callSignalRNotification);
    }
    disableBtns = true;
};
</script>

<style src="./call-notification.scss"></style>
